import { render, staticRenderFns } from "./QuotationDiscounts.vue?vue&type=template&id=364ce50a&"
import script from "./QuotationDiscounts.vue?vue&type=script&lang=js&"
export * from "./QuotationDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports